<ng-container [ngSwitch]="bankDetailsVerificationStatus$ | async">
	<div class="obg-m-iaui-notification-pending" *ngSwitchCase="pending">
		<span class="iaui-notification-icon ico-information-circle"></span>
		<label>{{ "customer-verification.notification.verification-pending" | translate }}</label>
		<a (click)="dismiss()">{{ "customer-verification.notification.dismiss" | translate }}</a>
	</div>
	<div class="obg-m-iaui-notification-denied" *ngSwitchCase="denied">
		<span class="iaui-notification-icon ico-information-circle"></span>
		<label>{{ "customer-verification.notification.verification-denied" | translate }}</label>
		<a (click)="dismiss()">{{ "customer-verification.notification.dismiss" | translate }}</a>
	</div>
	<div class="obg-m-iaui-notification-unverified" *ngSwitchDefault>
		<span class="iaui-notification-icon ico-information-circle icon-info-circle-black"></span>
		<label>{{ "customer-verification.notification.verify-completion" | translate }}</label>
		<a (click)="verify()">{{ "customer-verification.notification.verify" | translate }}</a>
	</div>
</ng-container>
